/**
 * 
 * Input Box
 * 
 */

import React from 'react';
import { UPLOAD_NAME_CONCAT } from '../../utility';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import UploadImage from '../../../assets/images/uploadImg.svg';
import axios from '../../../axios-url';
import { saveAs } from 'file-saver';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';

{/*this component has 4 input through props
     1. handleAttachment = {this.handleAttachment} this is for passing value to process pages
     2. folderName = 'ExpenseClaim' this is the foldename which varies from process to process so as to save respective attachments to respective folders
     3. reloadedValues = {this.state.requestattachments} to repopulate the attachments so in the upcoming aproval stages 
     4. isReloaded = {(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} to determine whether the pages are reloaded
     5. heading = this node is for getting the heading for the attachment table.
*/}
let onceLoaded = false;// New update

class InputBox extends React.Component {

    state = {
            loading: false,
            attachmentData: []
        }
    

    addAttachmentContainer = (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        let file = e.target.files[0];
        if(!file){
            this.setState({loading:false});
            return;
        }
        // Check for duplicate original file name
        const isDuplicate = this.state.attachmentData.some(att => att.fileName === 'Attachments_' + UPLOAD_NAME_CONCAT + '_' + file.name);
        if (isDuplicate) {
            this.setState({ loading: false });
            if (this.growl) {
                this.growl.show({ severity: 'warn', summary: 'Duplicate File', detail: 'This file has already been attached.' });
            }
            return;
        }
        let name = 'Attachments_' + UPLOAD_NAME_CONCAT + '_' + file.name;
        const frmData = new FormData();
        frmData.append('file', file, name);
      
        axios.post(`/master/api/upload?FolderName=${this.props.folderName}`, frmData)
        .then(response => {
            if(response.status == 200){
                let fileExtension = response.data.fileExtention;
                let fileName = response.data.fileName;
                let filePath = response.data.filePath;
                let virtualFilePath = response.data.virtualFilePath;
                let folderName = this.props.folderName;
                this.setState({ loading: false, attachmentData: this.state.attachmentData.concat(Object.assign({}, { fileExtension: fileExtension, filePath: filePath, fileName: fileName, virtualFilePath, folderName })) });
                setTimeout(() => {
                    this.props.handleAttachment(this.state.attachmentData, 'add');
                },300)                
            }

        }).catch(err => {
            this.growl.show({ severity: 'error', summary: null, detail: 'File Upload Failed' });
            this.setState({ loading: false });
        })
    }

    componentDidMount() {
        const { readonly, isReloaded, reloadedValues } = this.props;
        const { attachmentData, loading } = this.state;
        if(isReloaded || (reloadedValues.length > 0)){
            this.reloadValues(reloadedValues);
        }
    }

    downloadEmployeeData = (rowData) => {

        this.setState({loading:true});
        let extension = rowData.fileExtension;
        let fileName = rowData.fileName;
        let folderName = rowData.folderName;

        axios({
            url: `/master/api/Download?filename=${rowData.fileName}&&FolderName=${folderName}&&ext=${rowData.fileExtension}`,
            method: 'GET',
            responseType: 'blob', // important
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${fileName + extension}`);
            document.body.appendChild(link);
            link.click();
            this.setState({loading: false})
          }).catch((err) => {
            this.growl.show({ severity: 'error', summary: 'null', detail: 'File Download failed, please try again.' });
          })
    }

    downloadTemplate = (rowData) => {
        return <div className="actionCenter">
            <Button type="button" icon="pi pi-download" onClick = {() =>this.downloadEmployeeData(rowData)}  className="p-button-info" ></Button>
        </div>;
    }

    deleteTemplate = (rowData) => {
        return <div className="actionCenter">
            <Button className="p-button-danger" icon="pi pi-trash" onClick={() => this.handleDeleteTemplate(rowData)} />
        </div>;
    }

    handleDeleteTemplate(rowData) {
        let newAttachmentData = this.state.attachmentData.filter(_ => _.fileName != rowData.fileName);
        this.setState({ attachmentData: newAttachmentData })
        this.props.handleAttachment(newAttachmentData, 'delete');
    }

    reloadValues(data) {
        let folderName = this.props.folderName;
        let attachments = data.map(el => {
            return{
                fileExtension: el.extension, 
                filePath: el.uploadPath, 
                fileName: el.fileName, 
                folderName 
            }
        })
        this.setState({attachmentData:attachments})
    }


    render() {

        const { readonly, isReloaded, reloadedValues, heading , showTable = true } = this.props;//heading
        const { attachmentData, loading } = this.state;
        let tableHeader = heading ? heading : 'Attachments'
        
        // New update
        let tableData = [];
        if(!onceLoaded){
            this.reloadValues(this.props.reloadedValues);
            onceLoaded = true;
        }
        
        //
        return (<div className="p-col-12">
            <Toast ref={(el) => this.growl = el} />
            <h1>{tableHeader}</h1> {/* New update*/}
            <div className="p-grid ">
                <div className="p-col-12 p-lg-12">
                    <div className="mt1">
                        {(!isReloaded) && 
                        <div>
                            <input type="file" readOnly={readonly} name="file" id="file-7" className="inputfile inputfile-6" onChange={(e) => this.addAttachmentContainer(e)} />
                            <label htmlFor="file-7">
                                <span></span>
                                <strong><img src={UploadImage} alt="upload im" /> Choose a file&hellip;</strong>
                            </label>
                        </div>}
                    </div>
                </div>
                <div className="p-col-12 p-lg-12">
                {loading && <div className="page-loader"></div>}
                </div>
                {
                this.props.showTable !== false && (
                <div className="p-col-12 p-lg-12">
                    <DataTable className="animated fadeInLeft" rowHover emptyMessage="No records found..." responsive={true} rows={10} value={attachmentData}>
                        <Column field="fileName" sortable={true} header="File Name" />
                        <Column field="fileExtension" sortable={true} header="File Extension" />
                        <Column field="filePath" sortable={true} header="Download" body={this.downloadTemplate} />
                        {(!isReloaded) && <Column body={this.deleteTemplate} header="Action" />}
                    </DataTable>
                </div>
                  )
                 }
            </div>
        </div>)
    }
}


export default InputBox;